var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 206 40.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eaa0c6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "base"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,40.5a81.75,81.75,0,0,1,10.41-9.36,127.24,127.24,0,0,1,11.54-8A152.55,152.55,0,0,1,47.22,10.68,159.89,159.89,0,0,1,103,0a155.36,155.36,0,0,1,28.56,2.42c2.34.46,4.69.92,7,1.41S143.2,5,145.5,5.65l3.44,1,3.39,1.14c2.24.8,4.49,1.57,6.71,2.39s4.37,1.85,6.54,2.79c1.08.48,2.17.93,3.24,1.43S170.93,15.44,172,16c2.09,1.1,4.19,2.17,6.25,3.29l6,3.71a129.8,129.8,0,0,1,11.41,8.16c1.87,1.36,3.56,3,5.31,4.55s3.42,3.15,5.06,4.8c-2.25-.68-4.44-1.45-6.61-2.2l-3.22-1.16-1.6-.59L192.93,36c-2.18-.68-4.31-1.42-6.44-2.12-1.08-.34-2.1-.78-3.19-1.07l-3.24-.94L173.69,30c-2.16-.54-4.29-1.13-6.42-1.69-1.06-.28-2.13-.55-3.18-.86s-2.14-.49-3.21-.73c-2.14-.49-4.27-1-6.38-1.48L148.09,24l-3.19-.63-3.21-.46c-2.14-.31-4.27-.68-6.4-1s-4.29-.46-6.42-.72A239.91,239.91,0,0,0,103.17,20,268.56,268.56,0,0,0,51.68,25.7c-8.59,1.74-17.16,3.92-25.75,6.39S8.75,37.33,0,40.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset4);
export default __webpack_public_path__ + "static/media/Asset 4.f977a932.svg";
export { ForwardRef as ReactComponent };